import { render, staticRenderFns } from "./AboutUsHomeHeader.vue?vue&type=template&id=0b2cdccd&scoped=true&"
import script from "./AboutUsHomeHeader.vue?vue&type=script&lang=js&"
export * from "./AboutUsHomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsHomeHeader.vue?vue&type=style&index=0&id=0b2cdccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cdccd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
